export default __webpack_public_path__ + "static/media/nextJS.772bcfed.svg";